module.exports = __webpack_public_path__ + "static/media/meta.9361c42a.bin";